
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"y":".75","width":"25","height":"25","rx":"12","fill":"#C5C5C5"}}),_c('path',{attrs:{"d":"M8.056 8.25a.556.556 0 00-.556.556 9.445 9.445 0 009.444 9.444.556.556 0 00.556-.556V15.75a.555.555 0 00-.556-.556 6.313 6.313 0 01-1.983-.316.567.567 0 00-.567.133l-1.222 1.222a8.358 8.358 0 01-3.66-3.66l1.221-1.229a.533.533 0 00.14-.555 6.313 6.313 0 01-.317-1.983A.556.556 0 0010 8.25H8.056zm6.11 0v.833h1.945l-3.055 3.056.555.555 3.056-3.055v1.944h.833V8.25h-3.333z","fill":"#546D7A"}})])
          )
        }
      }
    